// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviewImpactProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ReviewImpactProjectQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Region', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Market', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Community', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Lot', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Structure', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
    | { __typename?: 'Unit', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string }, projectCostCodes: Array<{ __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } }> }
  , projectItemsPage: { __typename?: 'ProjectItemsPage', pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type ReviewProjectImpactChangeEventQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type ReviewProjectImpactChangeEventQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } } }> } };

export type ReviewProjectImpactCheckoutConfigQueryVariables = Types.Exact<{
  structureId: Types.Scalars['ID']['input'];
  configId: Types.Scalars['ID']['input'];
}>;


export type ReviewProjectImpactCheckoutConfigQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, isAdu: boolean }, checkoutConfig: { __typename?: 'CheckoutConfig', id: string, productOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined, mhOptionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined }>, aduOptionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined }> } };

export type ReviewProjectImpact_StructureFragment = { __typename?: 'Structure', id: string, isAdu: boolean };

export type ReviewProjectImpactComputeCostQueryVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
  readyPlanOptionIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ReviewProjectImpactComputeCostQuery = { __typename?: 'Query', computeReadyPlanCost: { __typename?: 'ComputeReadyPlanCostResult', protoProjectItems: Array<{ __typename?: 'ProtoProjectItem', totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } } }> } };

export type ReviewProjectImpact_ProtoProjectItemFragment = { __typename?: 'ProtoProjectItem', totalCostInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } } };

export type ReviewProjectImpact_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, productOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined, aduProductOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined, mhOptionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined }>, aduOptionGroups: Array<{ __typename?: 'CheckoutConfigOptionGroup', id: string, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined }> };

export type ReviewProjectImpact_OptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, option: { __typename?: 'ReadyPlanOption', id: string } } | null | undefined };

export type ReviewProjectImpact_ProjectCostCodeFragment = { __typename?: 'ProjectCostCode', id: string, totalCostInCents: number, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } };

export type ReviewProjectImpact_CostCodeFragment = { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } };

export type ReviewProjectImpact_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } } }> };

export type ReviewProjectImpact_ChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', id: string, totalCostInCents: number, totalPriceInCents: number, typeDetail: { __typename?: 'ChangeEventLineItemTypeDetail', code: Types.ChangeEventLineItemType, name: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, division: { __typename?: 'CostDivision', id: string, name: string } } } };

export const ReviewProjectImpact_StructureFragmentDoc = gql`
    fragment ReviewProjectImpact_Structure on Structure {
  id
  isAdu
}
    `;
export const ReviewProjectImpact_CostCodeFragmentDoc = gql`
    fragment ReviewProjectImpact_CostCode on CostCode {
  id
  displayName
  division {
    id
    name
  }
}
    `;
export const ReviewProjectImpact_ProtoProjectItemFragmentDoc = gql`
    fragment ReviewProjectImpact_ProtoProjectItem on ProtoProjectItem {
  totalCostInCents
  item {
    id
    costCode {
      ...ReviewProjectImpact_CostCode
    }
  }
}
    ${ReviewProjectImpact_CostCodeFragmentDoc}`;
export const ReviewProjectImpact_OptionGroupFragmentDoc = gql`
    fragment ReviewProjectImpact_OptionGroup on CheckoutConfigOptionGroup {
  id
  selectedOption {
    id
    option {
      id
    }
  }
}
    `;
export const ReviewProjectImpact_CheckoutConfigFragmentDoc = gql`
    fragment ReviewProjectImpact_CheckoutConfig on CheckoutConfig {
  id
  productOffering {
    id
  }
  aduProductOffering {
    id
  }
  mhOptionGroups {
    ...ReviewProjectImpact_OptionGroup
  }
  aduOptionGroups {
    ...ReviewProjectImpact_OptionGroup
  }
}
    ${ReviewProjectImpact_OptionGroupFragmentDoc}`;
export const ReviewProjectImpact_ProjectCostCodeFragmentDoc = gql`
    fragment ReviewProjectImpact_ProjectCostCode on ProjectCostCode {
  id
  totalCostInCents
  costCode {
    ...ReviewProjectImpact_CostCode
  }
}
    ${ReviewProjectImpact_CostCodeFragmentDoc}`;
export const ReviewProjectImpact_ChangeEventLineItemFragmentDoc = gql`
    fragment ReviewProjectImpact_ChangeEventLineItem on ChangeEventLineItem {
  id
  totalCostInCents
  totalPriceInCents
  typeDetail {
    code
    name
  }
  item {
    id
    costCode {
      ...ReviewProjectImpact_CostCode
    }
  }
}
    ${ReviewProjectImpact_CostCodeFragmentDoc}`;
export const ReviewProjectImpact_ChangeEventFragmentDoc = gql`
    fragment ReviewProjectImpact_ChangeEvent on ChangeEvent {
  id
  lineItems {
    ...ReviewProjectImpact_ChangeEventLineItem
  }
}
    ${ReviewProjectImpact_ChangeEventLineItemFragmentDoc}`;
export const ReviewImpactProjectDocument = gql`
    query ReviewImpactProject($projectId: ID!) {
  project(id: $projectId) {
    id
    lotType {
      code
      clientNoun
    }
    projectCostCodes {
      ...ReviewProjectImpact_ProjectCostCode
    }
  }
  projectItemsPage(
    filter: {project: [$projectId], isRemovedScope: false}
    page: {offset: 0, limit: 1}
  ) {
    pageInfo {
      totalCount
    }
  }
}
    ${ReviewProjectImpact_ProjectCostCodeFragmentDoc}`;

/**
 * __useReviewImpactProjectQuery__
 *
 * To run a query within a React component, call `useReviewImpactProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewImpactProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewImpactProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useReviewImpactProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables> & ({ variables: ReviewImpactProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>(ReviewImpactProjectDocument, options);
      }
export function useReviewImpactProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>(ReviewImpactProjectDocument, options);
        }
// @ts-ignore
export function useReviewImpactProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>;
export function useReviewImpactProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewImpactProjectQuery | undefined, ReviewImpactProjectQueryVariables>;
export function useReviewImpactProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>(ReviewImpactProjectDocument, options);
        }
export type ReviewImpactProjectQueryHookResult = ReturnType<typeof useReviewImpactProjectQuery>;
export type ReviewImpactProjectLazyQueryHookResult = ReturnType<typeof useReviewImpactProjectLazyQuery>;
export type ReviewImpactProjectSuspenseQueryHookResult = ReturnType<typeof useReviewImpactProjectSuspenseQuery>;
export type ReviewImpactProjectQueryResult = ApolloReactCommon.QueryResult<ReviewImpactProjectQuery, ReviewImpactProjectQueryVariables>;
export const ReviewProjectImpactChangeEventDocument = gql`
    query ReviewProjectImpactChangeEvent($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    ...ReviewProjectImpact_ChangeEvent
  }
}
    ${ReviewProjectImpact_ChangeEventFragmentDoc}`;

/**
 * __useReviewProjectImpactChangeEventQuery__
 *
 * To run a query within a React component, call `useReviewProjectImpactChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewProjectImpactChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewProjectImpactChangeEventQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useReviewProjectImpactChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables> & ({ variables: ReviewProjectImpactChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>(ReviewProjectImpactChangeEventDocument, options);
      }
export function useReviewProjectImpactChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>(ReviewProjectImpactChangeEventDocument, options);
        }
// @ts-ignore
export function useReviewProjectImpactChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>;
export function useReviewProjectImpactChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectImpactChangeEventQuery | undefined, ReviewProjectImpactChangeEventQueryVariables>;
export function useReviewProjectImpactChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>(ReviewProjectImpactChangeEventDocument, options);
        }
export type ReviewProjectImpactChangeEventQueryHookResult = ReturnType<typeof useReviewProjectImpactChangeEventQuery>;
export type ReviewProjectImpactChangeEventLazyQueryHookResult = ReturnType<typeof useReviewProjectImpactChangeEventLazyQuery>;
export type ReviewProjectImpactChangeEventSuspenseQueryHookResult = ReturnType<typeof useReviewProjectImpactChangeEventSuspenseQuery>;
export type ReviewProjectImpactChangeEventQueryResult = ApolloReactCommon.QueryResult<ReviewProjectImpactChangeEventQuery, ReviewProjectImpactChangeEventQueryVariables>;
export const ReviewProjectImpactCheckoutConfigDocument = gql`
    query ReviewProjectImpactCheckoutConfig($structureId: ID!, $configId: ID!) {
  structure(id: $structureId) {
    ...ReviewProjectImpact_Structure
  }
  checkoutConfig(id: $configId) {
    ...ReviewProjectImpact_CheckoutConfig
  }
}
    ${ReviewProjectImpact_StructureFragmentDoc}
${ReviewProjectImpact_CheckoutConfigFragmentDoc}`;

/**
 * __useReviewProjectImpactCheckoutConfigQuery__
 *
 * To run a query within a React component, call `useReviewProjectImpactCheckoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewProjectImpactCheckoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewProjectImpactCheckoutConfigQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useReviewProjectImpactCheckoutConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables> & ({ variables: ReviewProjectImpactCheckoutConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>(ReviewProjectImpactCheckoutConfigDocument, options);
      }
export function useReviewProjectImpactCheckoutConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>(ReviewProjectImpactCheckoutConfigDocument, options);
        }
// @ts-ignore
export function useReviewProjectImpactCheckoutConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>;
export function useReviewProjectImpactCheckoutConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectImpactCheckoutConfigQuery | undefined, ReviewProjectImpactCheckoutConfigQueryVariables>;
export function useReviewProjectImpactCheckoutConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>(ReviewProjectImpactCheckoutConfigDocument, options);
        }
export type ReviewProjectImpactCheckoutConfigQueryHookResult = ReturnType<typeof useReviewProjectImpactCheckoutConfigQuery>;
export type ReviewProjectImpactCheckoutConfigLazyQueryHookResult = ReturnType<typeof useReviewProjectImpactCheckoutConfigLazyQuery>;
export type ReviewProjectImpactCheckoutConfigSuspenseQueryHookResult = ReturnType<typeof useReviewProjectImpactCheckoutConfigSuspenseQuery>;
export type ReviewProjectImpactCheckoutConfigQueryResult = ApolloReactCommon.QueryResult<ReviewProjectImpactCheckoutConfigQuery, ReviewProjectImpactCheckoutConfigQueryVariables>;
export const ReviewProjectImpactComputeCostDocument = gql`
    query ReviewProjectImpactComputeCost($readyPlanId: ID!, $readyPlanOptionIds: [ID!]!) {
  computeReadyPlanCost(
    input: {readyPlanId: $readyPlanId, readyPlanOptionIds: $readyPlanOptionIds, versionMode: CHECKOUT}
  ) {
    protoProjectItems {
      ...ReviewProjectImpact_ProtoProjectItem
    }
  }
}
    ${ReviewProjectImpact_ProtoProjectItemFragmentDoc}`;

/**
 * __useReviewProjectImpactComputeCostQuery__
 *
 * To run a query within a React component, call `useReviewProjectImpactComputeCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewProjectImpactComputeCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewProjectImpactComputeCostQuery({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *      readyPlanOptionIds: // value for 'readyPlanOptionIds'
 *   },
 * });
 */
export function useReviewProjectImpactComputeCostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables> & ({ variables: ReviewProjectImpactComputeCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>(ReviewProjectImpactComputeCostDocument, options);
      }
export function useReviewProjectImpactComputeCostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>(ReviewProjectImpactComputeCostDocument, options);
        }
// @ts-ignore
export function useReviewProjectImpactComputeCostSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>;
export function useReviewProjectImpactComputeCostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewProjectImpactComputeCostQuery | undefined, ReviewProjectImpactComputeCostQueryVariables>;
export function useReviewProjectImpactComputeCostSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>(ReviewProjectImpactComputeCostDocument, options);
        }
export type ReviewProjectImpactComputeCostQueryHookResult = ReturnType<typeof useReviewProjectImpactComputeCostQuery>;
export type ReviewProjectImpactComputeCostLazyQueryHookResult = ReturnType<typeof useReviewProjectImpactComputeCostLazyQuery>;
export type ReviewProjectImpactComputeCostSuspenseQueryHookResult = ReturnType<typeof useReviewProjectImpactComputeCostSuspenseQuery>;
export type ReviewProjectImpactComputeCostQueryResult = ApolloReactCommon.QueryResult<ReviewProjectImpactComputeCostQuery, ReviewProjectImpactComputeCostQueryVariables>;